import React, { useState, useEffect } from "react";
import { Input, Button, Alert, Upload } from "antd";
import { SaveOutlined, ClearOutlined, CloseOutlined } from "@ant-design/icons";
import { SketchPicker } from 'react-color';
import cancelIcon from "../../app/assets/svgComponent/cancel.svg";
import saveIcon from "../../app/assets/svgComponent/save.svg";
import MenuItem from "@mui/material/MenuItem";

const OrganizationTableForm = ({
	item,
	onChange,
	onFileChange,
	onSave,
	onClear,
	editMode,
	setEditMode,
}) => {
	const [error, setError] = useState("");
	const [isFormValid, setIsFormValid] = useState(false);
	const [showColorPicker, setShowColorPicker] = useState(false);

	useEffect(() => {
		const isValid =
			item.name &&
			item.industry_type &&
			item.cities &&
			item.cities[0] &&
			item.cities[0].name &&
			item.cities[0].state &&
			item.cities[0].country &&
			item.no_employees !== "";
		setIsFormValid(isValid);
		if (isValid) {
			setError("");
		}
		
		if (editMode) {
			setShowColorPicker(false);
		}
	}, [item, editMode]);

	const handleEdit = () => {
		setEditMode(true);
		onChange({ target: { name: "item", value: item } });
	};

	const handleSave = () => {
		if (!isFormValid) {
			setError("All fields are required");
			return;
		}
		onSave();
		setEditMode(false);
	};

	const handleCityChange = (e) => {
		const { name, value } = e.target;
		onChange({
			target: {
				name: "cities",
				value: [{ ...item.cities[0], [name]: value }],
			},
		});
	};

	const handleAlphabeticInput = (e) => {
		e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
	};

	const handleNumericInput = (e) => {
		e.target.value = e.target.value.replace(/\D/g, '');
	};

	const handleFileChange = (e) => {
		onFileChange(e);
	};

	const handleColorChange = (e) => {
		if (e.target) {
			const colorValue = e.target.value;
			onChange({
				target: {
					name: 'color',
					value: colorValue.startsWith('#') ? { primary: colorValue } : colorValue
				}
			});
		} else {
			onChange({
				target: {
					name: 'color',
					value: { primary: e.hex }
				}
			});
		}
	};

	const inputStyle = {
		width: "368px",
		height: "34px",
		padding: "6px 10px",
		gap: "8px",
		borderRadius: "6px",
		border: "1px solid rgba(255, 255, 255, 1)",
		boxShadow: "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
		backgroundColor: "#F3F4F6",
		fontSize: "14px"
	};

	return (
		<div style={{ 
			width: "410px",
			height: "88vh",
			fontFamily: "inter",
			padding: "0",
			borderRadius: "12px",
			backgroundColor: "#FFFFFF",
			position: "fixed",
			right: "12px",
			top: "12px",
			boxShadow: `
				0px 20px 44px 0px rgba(0, 0, 0, 0.1),
				0px 80px 80px 0px rgba(0, 0, 0, 0.09),
				0px 180px 108px 0px rgba(0, 0, 0, 0.05),
				0px 319px 128px 0px rgba(0, 0, 0, 0.01),
				0px 499px 140px 0px rgba(0, 0, 0, 0)
			`,
			boxSizing: "border-box",
			display: "flex",
			flexDirection: "column",
			overflow: "hidden"
		}}>
			<div style={{
				width: "100%",
				height: "48px",
				padding: "8px 16px",
				borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				background: "rgba(247, 247, 248, 1)",
				flexShrink: 0,
				position: "relative"
			}}>
				<div style={{ 
					display: "flex", 
					alignItems: "center", 
					gap: "6px"
				}}>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M10.4965 4.90039H6.29648C5.52438 4.90039 4.89648 5.52829 4.89648 6.30039V11.9004H11.8965V6.30039C11.8965 5.52829 11.2686 4.90039 10.4965 4.90039ZM7.69648 9.80039C7.69648 10.1868 7.38358 10.5004 6.99648 10.5004C6.60938 10.5004 6.29648 10.1868 6.29648 9.80039V9.45039C6.29648 9.06399 6.60938 8.75039 6.99648 8.75039C7.38358 8.75039 7.69648 9.06399 7.69648 9.45039V9.80039ZM7.69648 7.35039C7.69648 7.73679 7.38358 8.05039 6.99648 8.05039C6.60938 8.05039 6.29648 7.73679 6.29648 7.35039V7.00039C6.29648 6.61399 6.60938 6.30039 6.99648 6.30039C7.38358 6.30039 7.69648 6.61399 7.69648 7.00039V7.35039ZM10.4965 9.80039C10.4965 10.1868 10.1836 10.5004 9.79648 10.5004C9.40938 10.5004 9.09648 10.1868 9.09648 9.80039V9.45039C9.09648 9.06399 9.40938 8.75039 9.79648 8.75039C10.1836 8.75039 10.4965 9.06399 10.4965 9.45039V9.80039ZM10.4965 7.35039C10.4965 7.73679 10.1836 8.05039 9.79648 8.05039C9.40938 8.05039 9.09648 7.73679 9.09648 7.35039V7.00039C9.09648 6.61399 9.40938 6.30039 9.79648 6.30039C10.1836 6.30039 10.4965 6.61399 10.4965 7.00039V7.35039Z" fill="#2563EB" />
						<path d="M2.79883 11.9003V3.32812C2.79883 3.01592 3.00603 2.74082 3.30633 2.65472L6.80633 1.65442C7.25363 1.52632 7.69883 1.86232 7.69883 2.32782V3.49962" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M2.09766 11.9004H11.8977" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					<span style={{ 
						fontWeight: "500",
						fontSize: "16px",
						marginTop: "5px"
					}}>
						{editMode?"Edit organisation":"Create new organisation"}
					</span>
				</div>
			</div>

			<div style={{ 
				padding: "24px 12px 24px 24px", 
				width: "100%",
				flex: 1,
				overflowY: "auto",
				overflowX: "hidden"
				
			}}>
				{error && <Alert type="error" message={error} style={{ marginBottom: "10px" }} />}
				
				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						Full Name <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="First & Last Name"
						name="name"
						value={item.name || ""}
						onChange={(e) => onChange(e)}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						PoC Name <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="First & Last Name"
						name="poc_name"
						value={item.poc_name || ""}
						onChange={(e) => onChange(e)}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						PoC E-mail <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="example@mail.com"
						name="poc_email"
						value={item.poc_email || ""}
						onChange={(e) => onChange(e)}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						Industry Type <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="select from a list"
						name="industry_type"
						value={item.industry_type || ""}
						onChange={(e) => { handleAlphabeticInput(e); onChange(e); }}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						City <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="Fill city name"
						name="name"
						value={item.cities && item.cities[0] ? item.cities[0].name : ""}
						onChange={(e) => { handleAlphabeticInput(e); handleCityChange(e); }}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						State <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="select from a list"
						name="state"
						value={item.cities && item.cities[0] ? item.cities[0].state : ""}
						onChange={(e) => { handleCityChange(e); handleAlphabeticInput(e); }}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						Country <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="select from a list"
						name="country"
						value={item.cities && item.cities[0] ? item.cities[0].country : ""}
						onChange={(e) => { handleCityChange(e); handleAlphabeticInput(e); }}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						Number of Employees <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="Enter number of employees"
						name="no_employees"
						value={item.no_employees}
						onChange={(e) =>{ onChange(e); handleNumericInput(e); }}
						style={inputStyle}
					/>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<label style={{
						display: "block",
						fontSize: "14px",
						color: "#374151",
						marginBottom: "8px",
						fontWeight: "500"
					}}>
						Enter color (hex) <span style={{ color: 'red' }}>*</span>
					</label>
					<Input
						placeholder="Enter color (hex)"
						name="color.primary"
						value={item.color?.primary || ''}
						onChange={(e) => onChange(e)}
						style={inputStyle}
					/>
				</div>

				<input onChange={handleFileChange} type="file" accept="image/png" placeholder="Upload PNG Logo" style={{ width:300}}/>

			</div>

			<div style={{ 
				width: "100%", 
				height: "80px", 
				display: "flex",
				gap: "10px",
				padding: "16px",
				background: "rgba(247, 247, 248, 1)",
				borderTop: "1px solid rgba(0, 0, 0, 0.1)",
				flexShrink: 0,
				justifyContent: "center",
				alignItems: "center",
				borderRadius: "12px 12px 0 0"
			}}>
				<img 
					src={cancelIcon} 
					onClick={onClear}
					alt="cancel" 
					style={{ 
						width: "180px",
						height: "50px",
						objectFit: "contain",
						cursor: "pointer",
						transition: "transform 0.2s"
					}}
					onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
					onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
					onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
				/>
				
				<img 
					src={saveIcon} 
					onClick={isFormValid ? handleSave : undefined}
					alt="save" 
					style={{ 
						width: "180px",
						height: "48px",
						objectFit: "contain",
						cursor: isFormValid ? "pointer" : "not-allowed",
						transition: "transform 0.2s",
						opacity: isFormValid ? 1 : 0.5
					}}
					onMouseDown={(e) => isFormValid && (e.currentTarget.style.transform = "scale(0.95)")}
					onMouseUp={(e) => isFormValid && (e.currentTarget.style.transform = "scale(1)")}
					onMouseLeave={(e) => isFormValid && (e.currentTarget.style.transform = "scale(1)")}
				/>
			</div>
		</div>
	);
};

export default OrganizationTableForm;
